import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  trafficStatus: [],
  loadingTrafficStatus: false,
};

const publicDataSlice = createSlice({
  name: 'trafficStatus',
  initialState,
  reducers: {
    getTrafficStatusData: () => {},
    saveTrafficStatusData: (state, { payload }) => {
      state.trafficStatus = payload;
      state.loadingTrafficStatus = false;
    },
    changeLoading: (state, { payload }) => {
      state.loadingTrafficStatus = payload;
    },
  },
});

export const {
  getTrafficStatusData,
  saveTrafficStatusData,
  changeLoading
} = publicDataSlice.actions;

export default publicDataSlice.reducer;
